import classNames from 'classnames';
import { dsClass } from '../../../../common/constants/dsClasses.js';
import { PlaceOrderSummaryView } from './PlaceOrderSummaryView.js';
import type { PlaceOrderSummaryViewProps, SimpleSummaryData } from './PlaceOrderSummaryView.js';

export type { DetailedSummaryData, TableRow } from './PlaceOrderSummaryView.js';

export interface SimpleSummaryDataCoCo extends SimpleSummaryData {
  monthlyCharges: number;
  oneTimeCharges: number;
}

export interface PlaceOrderSummaryViewCoCoProps extends Omit<PlaceOrderSummaryViewProps, 'simpleSummary'> {
  simpleSummary: SimpleSummaryDataCoCo;
}

export const PlaceOrderSummaryViewCoCo = (props: PlaceOrderSummaryViewCoCoProps) => {
  const { className, simpleSummary, ...viewProps } = props;
  const { monthlyCharges, oneTimeCharges, ...summary } = simpleSummary;

  return (
    <PlaceOrderSummaryView
      {...viewProps}
      className={classNames(dsClass.MARGIN_TOP_4, className)}
      simpleSummary={{
        ...summary,
        showMonthly: monthlyCharges > 0,
        showOneTime: oneTimeCharges > 0,
      }}
    />
  );
};
